export default {
    autenticacao: JSON.parse(localStorage.getItem('autenticacao')) || null,
    centroCusto: JSON.parse(localStorage.getItem('centro_custo')) || {},
    cliente: JSON.parse(localStorage.getItem('cliente') || null),
    customer: JSON.parse(localStorage.getItem('customer')) || null,
    loading: 0,
    lotacao: JSON.parse(localStorage.getItem('lotacao')) || {},
    menu: JSON.parse(localStorage.getItem('menu')) || null,
    showExitFormConfirmation: false,
    sidebar: localStorage.getItem('sidebar') === 'true' ? true : false,
}